// Unobtrusive Ajax support library for jQuery
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// @version v3.2.6
// 
// Microsoft grants you the right to use these script files for the sole
// purpose of either: (i) interacting through your browser with the Microsoft
// website or online service, subject to the applicable licensing or use
// terms; or (ii) using the files as included with a Microsoft product subject
// to that product's license terms. Microsoft reserves all other rights to the
// files not expressly granted by Microsoft, whether by implication, estoppel
// or otherwise. Insofar as a script file is dual licensed under GPL,
// Microsoft neither took the code under GPL nor distributes it thereunder but
// under the terms set out in this paragraph. All notices and licenses
// below are for informational purposes only.

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global window: false, jQuery: false */
/* eslint-disable @typescript-eslint/no-explicit-any */
(function ($: JQueryStatic) {
	let formSubmitInProgress = false; // Used to prevent multiple form submit
	const dataClick = "unobtrusiveAjaxClick",
		dataTarget = "unobtrusiveAjaxClickTarget",
		dataValidation = "unobtrusiveValidation";

	function getFunction(code: any, argNames: Array<string>) {
		let fn: any = window;
		const parts: Array<any> = (code || "").split(".");
		while (fn && parts.length) {
			fn = fn[parts.shift()];
		}
		if (typeof (fn) === "function") {
			return fn;
		}
		argNames.push(code);
		return Function.constructor.apply(null, argNames);
	}

	function isMethodProxySafe(method: string) {
		return method === "GET" || method === "POST";
	}

	function asyncOnBeforeSend(xhr: JQueryXHR, method: string) {
		if (!isMethodProxySafe(method)) {
			xhr.setRequestHeader("X-HTTP-Method-Override", method);
		}
	}

	function asyncOnSuccess(element: HTMLElement, data: any, contentType: string) {
		const updateAttr: string = element.getAttribute("data-ajax-update") || "";
		const position: JQueryCoordinates = { left: 0, top: 0 };

		if (contentType.indexOf("application/x-javascript") !== -1) {  // jQuery already executes JavaScript for us
			return;
		}

		if ((contentType.indexOf("application/json") !== -1) && (typeof data.newUrl !== "undefined")) {
			window.location = data.newUrl;
			return;
		}
		
		const mode = (element.getAttribute("data-ajax-mode") || "").toUpperCase();
		$(updateAttr).each(function (i: number, update: HTMLElement) {
			switch (mode) {
				case "BEFORE":
					$(update).prepend(data);
					break;
				case "AFTER":
					$(update).append(data);
					break;
				case "REPLACE-WITH":
					$(update).replaceWith(data);
					break;
				default:
					$(update).html(data);
					break;
			}

			$("html, body").animate({
				scrollTop: position.top
			}, 500);
		});
	}

	function asyncRequest(element: HTMLElement, options: any) {
		let method = "";

		const confirm = element.getAttribute("data-ajax-confirm") || null;
		if (confirm && !window.confirm(confirm)) {
			return;
		}

		const loading = $(element.getAttribute("data-ajax-loading") || "");
		const duration = parseInt(element.getAttribute("data-ajax-loading-duration") || "", 10) || 0;

		$.extend(options, {
			type: element.getAttribute("data-ajax-method") || undefined,
			url: element.getAttribute("data-ajax-url") || undefined,
			cache: (element.getAttribute("data-ajax-cache") || "").toLowerCase() === "true",
			beforeSend: function (xhr: JQueryXHR) {
				asyncOnBeforeSend(xhr, method);
				const result = getFunction(element.getAttribute("data-ajax-begin"), ["xhr"]).apply(element, arguments);
				if (result !== false) {
					loading.show(duration);
				}
				return result;
			},
			complete: function () {
				loading.hide(duration);
				getFunction(element.getAttribute("data-ajax-complete"), ["xhr", "status"]).apply(element, arguments);
				formSubmitInProgress = false;
			},
			success: function (data: any, status: string, xhr: JQueryXHR) {
				asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
				getFunction(element.getAttribute("data-ajax-success"), ["data", "status", "xhr"]).apply(element, arguments);

				apt.sm.setupPage(data);
			},
			error: function () {
				getFunction(element.getAttribute("data-ajax-failure"), ["xhr", "status", "error"]).apply(element, arguments);
			}
		});

		options.data.push({ name: "X-Requested-With", value: "XMLHttpRequest" });

		method = options.type.toUpperCase();
		if (!isMethodProxySafe(method)) {
			options.type = "POST";
			options.data.push({ name: "X-HTTP-Method-Override", value: method });
		}

		// change here:
		// Check for a Form POST with enctype=multipart/form-data
		// add the input file that were not previously included in the serializeArray()
		// set processData and contentType to false
		const $element = $(element);
		if ($element.is("form") && $element.attr("enctype") === "multipart/form-data") {
			const formdata = new FormData();
			$.each(options.data, function (i, v) {
				formdata.append(v.name, v.value);
			});
			$("input[type=file]", $element).each(function () {
				const file: HTMLInputElement = this as HTMLInputElement;
				$.each(file.files, function (n, v) {
					formdata.append(file.name, v);
				});
			});
			$.extend(options, {
				processData: false,
				contentType: false,
				data: formdata
			});
		}
		// end change

		$.ajax(options);
	}

	function validate(form: HTMLFormElement) {
		formSubmitInProgress = true; // Set to true to prevent multiple form submission
		const validationInfo = $(form).data(dataValidation);
		return !validationInfo || !validationInfo.validate || validationInfo.validate();
	}

	$(document).on("click", "a[data-ajax=true]", function (evt: any) {
		evt.preventDefault();
		asyncRequest(this, {
			url: this.href,
			type: "GET",
			data: []
		});
	});

	$(document).on("click", "form[data-ajax=true] input[type=image]", function (evt: any) {
		const name: string = evt.target.name,
			target: JQuery<HTMLElement> = $(evt.target),
			form: JQuery<Element> = $(target.parents("form")[0]),
			offset: JQuery.Coordinates | any = target.offset();

		form.data(dataClick, [
			{ name: name + ".x", value: Math.round(evt.pageX - offset.left) },
			{ name: name + ".y", value: Math.round(evt.pageY - offset.top) }
		]);

		setTimeout(function () {
			form.removeData(dataClick);
		}, 0);
	});

	$(document).on("click", "form[data-ajax=true] :submit", function (evt: any) {
		const name = evt.currentTarget.name,
			target = $(evt.target),
			form = $(target.parents("form")[0]);

		form.data(dataClick, name ? [{ name: name, value: evt.currentTarget.value }] : []);
		form.data(dataTarget, target);

		setTimeout(function () {
			form.removeData(dataClick);
			form.removeData(dataTarget);
		}, 0);
	});

	$(document).on("submit", "form[data-ajax=true]", function (evt: any) {
		$(this).off("submit"); //unbind previous submit handlers (prevent multiple events on same click)

		const clickInfo = $(this).data(dataClick) || [],
			clickTarget = $(this).data(dataTarget),
			isCancel = clickTarget && (clickTarget.hasClass("cancel") || clickTarget.attr("formnovalidate") !== undefined);
		evt.preventDefault();
		// Check if a form submit is already in progress
		if (formSubmitInProgress || (!isCancel && !validate(this))) {
			return;
		}
		asyncRequest(this, {
			url: clickTarget && clickTarget.attr("formaction") || this.action,
			type: this.method || "GET",
			data: clickInfo.concat($(this).serializeArray())
		});
	});
}(jQuery));
